import { SYSTEM_INCLUDES } from './SystemIncludes';

// Symbolic names for include bundles
export const SYMBOL_PRELUDE = 'prelude';

export type IncludeSymbol = typeof SYMBOL_PRELUDE | (string & {});

// The registry maps a symbol to an ordered array of include strings
const REGISTRY = new Map<IncludeSymbol, string[]>();

// Seed registry from system includes (ordered)
for (const [symbol, text] of SYSTEM_INCLUDES) {
  const arr = REGISTRY.get(symbol as IncludeSymbol) ?? [];
  arr.push(text);
  REGISTRY.set(symbol as IncludeSymbol, arr);
}

/** Resolve an include symbol to its prelude bundle, if known. */
export function resolveInclude(symbol: IncludeSymbol): string[] | undefined {
  return REGISTRY.get(symbol);
}

/** Return all registered symbols. Useful for tests or introspection. */
export function listIncludeSymbols(): IncludeSymbol[] {
  return Array.from(REGISTRY.keys());
}
